const PageRewardRegister = () => import('@/modules/xmsb/rewardregister/PageRewardRegister')

export default [
  {

    path: '/release/rewardregister',
    name: 'rewardregister',
    component: PageRewardRegister,
    meta: {
      title: '项目发布',
    },
  },
]
